<template>
  <v-app>
    <Navigation v-if="$store.state.loggedIn" />
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Navigation from './components/Navigation.vue';

export default {
  components: { Navigation },
};
</script>

<style>
.theme--light.v-application,
.theme--light.v-data-table {
  color: #313131;
}

th,
.subheading {
  text-transform: capitalize;
}

.one-line {
  overflow: hidden;
  line-height: 2rem;
  max-height: 8rem;
  display: block;
  display: -webkit-box;
  overflow: hidden !important;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
